import React from 'react';

interface MetricCardProps {
    title: string;
    value: string | number;
    change?: number;
    icon?: React.ReactNode;
    trend?: 'up' | 'down' | 'neutral';
}

export const MetricCard: React.FC<MetricCardProps> = ({ title, value, change, icon, trend }) => {
    return (
        <div className="metric-card">
            <div className="flex items-start justify-between mb-2">
                <h3 className="text-sm font-medium text-gray-600">{title}</h3>
                {icon && <div className="text-primary-500">{icon}</div>}
            </div>
            <div className="flex items-baseline gap-2">
                <p className="text-3xl font-bold text-gray-900">{value}</p>
                {change !== undefined && (
                    <span className={`text-sm font-medium ${trend === 'up' ? 'text-green-600' :
                            trend === 'down' ? 'text-red-600' :
                                'text-gray-600'
                        }`}>
                        {change > 0 ? '+' : ''}{change}%
                    </span>
                )}
            </div>
        </div>
    );
};
